export enum PageType {
    LANDING = 'n',
    CATEGORY = 'category',
    BRANDS = 'brands',
    NEWPRODUCTS = 'new-products',
    ALLPRODUCTS = 'all-products',
    STYLES = 'styles',
    HOMEPAGE = 'homepage',
    PDP = 'PDP',
    LLP = 'LLP',
    LOOKS = 'looks',
    ALICE_OTHER = 'alice-other',
    ALICE_WISHLIST = 'alice-wishlist',
    ALICE_INTERIOR_DESIGN_SERVICE = 'alice-interior-design-service',
    ALICE_STATIC_PAGE = 'alice-static-page',
    EXTERNAL = 'external',
    CART = 'cart',
    CART_NATIVE = 'cart-native',
    ALICE_CART = 'alice-cart',
    UNKNOWN = 'unknown',
    WISHLIST = 'wishlist',
    WISHLIST_NATIVE = 'wishlist-native',
    INTERIOR_DESIGN_SERVICE = 'interior-design-service',
    INTERIOR_DESIGN_SERVICE_NATIVE = 'interior-design-service-native',
}

export const ContentInfusionsAllowedPageTypes = [
    PageType.CATEGORY,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.NEWPRODUCTS,
];

export const ProductListingPages = [
    PageType.CATEGORY,
    PageType.NEWPRODUCTS,
    PageType.ALLPRODUCTS,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.STYLES,
];

export const ContentInfusionsPageTypeMapping = {
    [PageType.LANDING]: 'landing',
    [PageType.NEWPRODUCTS]: 'newproducts',
};

export enum FilterFacetsNames {
    DELIVERY_TIME = 'facet_delivery_time',
    PRICE = 'facet_price',
    STYLES = 'facet_styles',
}

export const WishListUrlList = [
    '/customer/wishlist',
    '/customer/wishlist/',
    '/customer/wishlist/index',
    '/customer/wishlist/index/',
];
